@if (bewelf) {
  <div class="flex flex-row justify-between flex-nowrap center-v pt-3 pb-3">
    <div class="flex flex-col flex-nowrap pl-3 pr-3 border-box">
      <div class="g custom-grid">
        <div>
          <div class="flex items-center gap-2">
            <span class="text-sm color-light">{{ bewelf?.artikelnummer }}</span>
            <soft-serial-number-view
              [productId]="$safeNavigationMigration(bewelf?.idartstamm)"
              [serialNumber]="value?.seriennr ?? bewelf?.seriennr"
              (serialNumberChange)="patchBewe($event)"
              [deliveryNoteId]="returnNoteId"
              [editable]="
                value?.seriennr?.editable ?? bewelf?.seriennr?.editable ?? false
              "
              [beweLfId]="bewelf?.id ?? $any(value)?.bewelf ?? $any(value)?.idbewelf"
            />
          </div>

          @if ((value?.files || []).length > 0) {
            <i
              class="fa-regular fa-images info-icon"
            ></i>
          }
        </div>
        <div
          class="flex gap-1 items-center flex-grow text-ellipsis overflow-hidden whitespace-nowrap"
          >
          @if ((value?.vermerk || '').length > 0) {
            <i
              class="fa-regular fa-note-sticky info-icon"
            ></i>
          }
          <div class="text-ellipsis overflow-hidden opacity-70">{{ value?.vermerk }}</div>
        </div>
      </div>

      <div class="mt-1 mb-1">
        @if (bewelf?.bezeichnung1?.length) {
          <p class="text-base font-semibold">
            {{ bewelf?.bezeichnung1 }}
          </p>
        }
        @if (bewelf?.bezeichnung2?.length) {
          <p class="text-base text-light">
            {{ bewelf?.bezeichnung2 }}
          </p>
        }
        @if (bewelf?.bezeichnung3?.length) {
          <p class="text-base text-light">
            {{ bewelf?.bezeichnung3 }}
          </p>
        }
      </div>
      @if (!bewelf?.bezeichnung1 && bewelf?.zeilentext?.length) {
        <p
          class="text-base font-semibold mt-1 mb-1"
          >
          {{ bewelf?.zeilentext }}
        </p>
      }
      @if (artehBean) {
        <span class="color-tertiary">
          {{ artehBean?.maxRetourmenge || 0 | number: '1.0-3' }} {{ artehBean.arteh }}
          {{ '#DELIVERY_NOTE.RETOUR.LIST_ITEM_QTY_SUFFIX' | translate }}
        </span>
      }
      @if (value && isSearchItem(value)) {
        <span class="text-base mt-1 italic"
          >Retour zu Lieferschein {{ value?.deliveryNote }} vom
          {{ $safeNavigationMigration(value?.date) | date }}</span
          >
        }
      </div>
      <div class="flex flex-row justify-end flex-nowrap center-v pl-3 border-box">
        <div class="flex relative">
          @if (
            (!addedFromSearch && hasError) || (hasError && addedFromSearch && !hasSplit)
            ) {
            <small
              class="absolute left-0 bottom-9 text-error-700 text-xs font-medium"
              >
              @if (value?.artehBean?.maxRetourmenge) {
                max. {{ $safeNavigationMigration(value?.artehBean?.maxRetourmenge) | number: '1.2-3' }}
                {{ value?.artehBean?.arteh }}
              } @else if (
                $safeNavigationMigration(value?.menge) === undefined || $safeNavigationMigration(value?.menge) === null || (value?.menge ?? 0) < 0
                ) {
                Keine Menge
              } @else {
                Retourmenge überschritten
              }
            </small>
          }
          @if (addedFromSearch && hasSplit) {
            <small
              class="absolute left-0 bottom-9 text-warning-700 text-xs font-medium"
              >
              Wird aufgeteilt
              <!-- max. {{ value?.artehBean?.maxRetourmenge | number: '1.2-3' }} {{ value?.artehBean?.arteh }} -->
            </small>
          }
          <ng-container>
            <soft-number-input
              placeholder="Menge"
              [value]="value?.menge ?? null"
              [class.error]="hasError"
              [changeTrigger]="deliveryNoteConfig?.openDialogMaxMenge ? 'blur' : 'input'"
              style="max-width: 80px"
              (valueChange)="onChange(value, menge.value(), arteh.value(), menge)"
              #menge
              >
            </soft-number-input>
            <div style="width: 100px" class="ml-2">
              <soft-select
                placeholder="EH"
                [value]="value?.artehBean ?? artehBean"
                [class.hidden]="bewelf.artehBeans?.length === 1"
                (valueChange)="onChange(value, menge.value(), arteh.value(), menge)"
                #arteh
                >
                @for (option of bewelf.artehBeans; track option) {
                  <soft-select-option
                    [value]="option"
                    >
                    {{ option?.arteh }}
                  </soft-select-option>
                }
              </soft-select>
              <span
                class="soft-title ml-3 color-light"
                style="width: 100px"
                [class.hidden]="bewelf.artehBeans?.length !== 1"
                >{{ bewelf?.einheit || '' }}</span
                >
              </div>
              @if (artehBean) {
                <small class="absolute left-0 top-9 text-gray-600 text-xs">
                  max. {{ $safeNavigationMigration(artehBean?.maxRetourmenge) | number: '1.2-3' }} {{ artehBean?.arteh }}
                </small>
              }
            </ng-container>
          </div>
          <span class="detail-area ml-4" (click)="onEditBeweClick(value)">
            <i class="fa-regular fa-ellipsis-vertical"></i>
          </span>
          <span class="detail-area">
            <i
              class="fa-regular fa-delete-left pointer p-1"
          [ngStyle]="{
            color:
              !!value?.menge || !!menge?.value()
                ? 'var(--colorError)'
                : 'rgba(0, 0, 0, 0.33)',
          }"
              (click)="onDeleteBeweClick(value); menge.value.set(null)"
            ></i>
          </span>
        </div>
      </div>
    }
